import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { IsEnglish } from '../../utils/language';

import AlertAlgo from '../controls/AlertSnack'

import styles from '../../styles/survey.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    },
    divBody: {
        marginTop: '35px'
    }
}));

export function SurveyPresentation(props) {
    const classes = useStyles();

    const [data, setData] = React.useState(null);

    const alertRef = useRef(null);

    useEffect(() => {
        if (props.data != null) {
            setData(props.data);
        }
    }, [props.data]);

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    return (
        <div className={`${styles.rootPopBody} ${classes.divBody}`}>
            <div dangerouslySetInnerHTML={{ __html: `${IsEnglish() ? (data?.htmlEn ?? '') : (data?.htmlFr ?? '')}` }} />
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['survey', 'error'], { wait: true })(SurveyPresentation);